import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext"; // ✅ Usar contexto de autenticación

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth(); // ✅ Usar estado global de sesión

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default PrivateRoute;
